import React from 'react';
import { Redirect } from 'react-router-dom';
import useAuth from '../utils/firebase';
import { Paper, Typography } from '@material-ui/core';
import { Button, Form, Container } from 'react-bootstrap';
import './login.scss';

export default function Login(props) {
    const { signin, user } = useAuth()

    const SignIn = e => {
        e.preventDefault();
        const { email, password } = e.target.elements

        try {
            signin(email.value, password.value);
        } catch (error) {
            console.log('error on login', error);
        }
    }

    return (
        user ?
            <Redirect to="/home" />
            :
            <div>
                <Container>
                    <Typography variant="h3" align="center">Essentiel Foot</Typography>
                    <Typography variant="h5" align="center">Connexion</Typography>
                </Container>
                <Paper className="login-paper">
                    <Form className="login-form" onSubmit={SignIn}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Adresse email</Form.Label>
                            <Form.Control name="email" id="email" type="email" placeholder="Enter email" />
                            <Form.Text className="text-muted">We'll never share your email with anyone else.</Form.Text>
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Mot de passe</Form.Label>
                            <Form.Control name="password" id="password" type="password" placeholder="Password" />
                        </Form.Group>
                        <Button variant="primary" type="submit" >Connexion</Button>
                    </Form>
                </Paper>
            </div>
    )

}